import router from '@/router'
import { RouteLocationNormalized } from 'vue-router'

router.beforeEach(async (to: RouteLocationNormalized, _: RouteLocationNormalized, next: any) => {
  next()
})

router.afterEach((to: RouteLocationNormalized) => {
  // console.log(to)
  // Finish progress bar
  // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939

  // set page title
  // document.title = getPageTitle(to.meta.title)
})
